import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-smartlock-delete-future-codes',
  templateUrl: './dialog-smartlock-delete-future-codes.component.html',
  styleUrls: ['./dialog-smartlock-delete-future-codes.component.scss'],
})
export class DialogSmartlockDeleteFutureCodesComponent implements OnInit {
  integration_id: string;
  deleteFutureCodes: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogSmartlockDeleteFutureCodesComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit() { }

  save() {
    // TODO: create logic for deleting all future codes when functionality is ready on microservice
    this.dialogRef.close();
  }
}
